import {Action} from "../services/HistoryService";

export function getUndoRemovalMessage(action: Action): string {
  switch (action) {
    case Action.RemoveItem: return 'Item removed';
    case Action.RemoveSection: return 'Section removed';
    default: return 'Menu removed';
  }
}
